import "./BottomBanner.scss";

export type BottomBannerProps = {
  value: string;
  link: string;
  className?: string;
  action: () => any;
};

const BottomBanner: React.FC<BottomBannerProps> = (
  props: BottomBannerProps
) => {
  return (
    <div className={"bottom-banner " + props.className}>
      <p className="bottom-banner__caption">{props.value}</p>
      <p className="bottom-banner__link" onClick={props.action}>
        {props.link}
      </p>
    </div>
  );
};

export default BottomBanner;
